const UNITS = ['Кб', 'Мб', 'Гб', 'Тб'];

export const formatTraffic = (kb) => {
  let value = kb || 0;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024;
    unitIndex++;
  }

  const formattedValue = Number(value?.toFixed(2));

  return `${formattedValue} ${UNITS[unitIndex]}`;
};
